import styled from 'styled-components';

import { FONT_FAMILY_MAIN } from '../../main-app/theme';

export const ToolbarButton = styled.button`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: ${({ isAvisSolution }) => isAvisSolution ? '#313b82' : '#4a90e2'};
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-family: ${FONT_FAMILY_MAIN};
  
  ${(props) => props.bold
  && `
    font-weight: bold;
  `};
`;
